define('drops/calendarItem/calendarItem',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/html'
], function ($, _, Drop, Style, html) {
    'use strict';

    var defaults = {
        data: {
            eventing: {
                clicked: {}
            },
            updateParams: {
            },
            createParams: {
            },
            longPressDelay: 1000,
            allowItemOverlap: true,
        }
    };

    function CalendarItem(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        this.$element
            .addClass('calendar-item boxToBorderSize')
            .css({
                touchAction: 'auto'
            });

        if(this.data.row && this.data.eventArg)
            this.defaultEventArg = this.data.row[this.data.eventArg];

        this.addListener('ChildAdded', function (childDrop) {
            self.applyDataAndChildAddedListener(childDrop);
        });

        Style.renderStyles(this);
    };

    Drop.extend(CalendarItem, Drop);

    CalendarItem.typeName = 'CalendarItem';

    CalendarItem.prototype.preRender = function () {
        this.applyPosition();
    };

    CalendarItem.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    CalendarItem.prototype.postRender = function () {
        if (this.data.row) {
            var tooltip = this.data.row[this.data.tooltipOutput];
            if (tooltip) this.$element.attr('title', html.strip(tooltip));
        }
    };

    CalendarItem.prototype.applyDataAndChildAddedListener = function (childDrop) {
        var self = this;
        this.applyDataToChild(childDrop);
        childDrop.addListener('ChildAdded', function (childDrop) {
            self.applyDataAndChildAddedListener(childDrop);
        });
    };

    CalendarItem.prototype.applyDataToChild = function (childDrop) {
        if (!this.data.row)
            return;

        childDrop.defaultEventArg = this.defaultEventArg;

        // quick hack
        var self = this;
        _.defer(function () {
            if (childDrop.setValue && _.has(self.data.row, childDrop.data.name)) {
                childDrop.setValue({
                    type: self.data.outputs[childDrop.data.name],
                    value: self.data.row[childDrop.data.name]
                });
            }

            childDrop.informListeners('DatasourceApplied', self.data.row);
        });
    };

    CalendarItem.prototype.applyPosition = function() {
        var lengthOfDay = this.data.endOfDay.diff(this.data.startOfDay, "minutes");
        var lengthOfItem = this.data.endOfItem.diff(this.data.startOfItem, 'minutes');
        var lengthToSkip = this.data.startOfItem.diff(this.data.startOfDay, 'minutes');

        if (this.data.layoutMode === 'horizontal') {
            var $container = this.data.$target;
            var $timeslot = $container.length ? $container.siblings('.timeslot').first() : $();
            var timeslotWidth = $timeslot.length ? (parseFloat($timeslot.css('width')) || 30) : 30;
            var $baseTimeslot = $container.length ? $container.closest('.planning-view').find('.hours .timeslot').first() : $();
            var timeslotHeight = $baseTimeslot.length ? (parseFloat($baseTimeslot.css('height')) || 60) : 60;
            var itemHeight = (this.data.size && this.data.size.y != null) ? this.data.size.y : timeslotHeight;
            var numTimeslots = $container.siblings('.timeslot').length;
            var timeslotSize = numTimeslots > 0 ? lengthOfDay / numTimeslots : 30;
            var pixelsPerMinute = timeslotWidth / timeslotSize;
            var leftPx = lengthToSkip * pixelsPerMinute;
            var widthPx = lengthOfItem * pixelsPerMinute;
            var overlapLayout = this.overlapLayout;
            var topVal = overlapLayout ? ((overlapLayout.columnIndex) * itemHeight) + 'px' : 0;
            this.$element.css({
                left: leftPx + 'px',
                width: widthPx + 'px',
                top: topVal, //stacked
                height: itemHeight + 'px'
            });
        } else {
            var height = (100 / lengthOfDay) * lengthOfItem;
            var top = (100 / lengthOfDay) * lengthToSkip;

            this.$element
                .css({
                    top: top + '%',
                    height: height + '%'
                });
        }
    };

    CalendarItem.prototype.unsubscribeEventHandlers = function () {
        this.piping.cleanUp();
    };

    return CalendarItem;
});
